module.exports = __webpack_public_path__ + "static/media/tableFuki.947b4e3d.png";